var createElementIdSelector = function (selector) {
    return "[data-elementid=\"" + selector + "\"]";
};
export default createElementIdSelector;
